"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowEqual;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectIs = _interopRequireDefault(require("./objectIs"));

/**
 * @param {Object} objA
 * @param {Object} objB
 * @returns {boolean} true if `objA[x] === objB[x]` for all `x`, and vice versa
 */
function shallowEqual(objA, objB) {
  if ((0, _objectIs.default)(objA, objB)) {
    return true;
  }

  if ((0, _typeof2.default)(objA) !== 'object' || objA === null || (0, _typeof2.default)(objB) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !(0, _objectIs.default)(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.102/js/shallowEqual.js
// module id = 679
// module chunks = 5 6